<template>
  <transition name="slide-fade">
    <div class="alert" :class="'alert-' + type" v-if="show">
      <font-awesome-icon icon="check-circle" size="lg" class="icon" v-if="type == 'success'"/>
      <font-awesome-icon icon="exclamation-circle" size="lg" class="icon" v-if="type == 'danger'"/>
      {{ message }}
    </div>
  </transition>
</template>

<style lang="scss">
@import "../assets/styles/main.scss";

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter {
  transform: translateY(20px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>

<script>
export default {
  name: "Alert",
  data() {
    return {
      show: false,
      message: "",
      type: "success",
      timeout: null
    };
  },
  methods: {
    showAlert(options) {
      clearTimeout(this.timeout);
      this.type = options.type;
      this.message = options.message;
      this.show = true;
      this.timeout = setTimeout(() => {
        this.show = false;
      }, 3000);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Alert.vue